import type { ComponentProps } from 'react';
import { ModuleGate } from '@givmo/org-console';
import { FUNDRAISERS_SLUG } from './fundraisers-routes';

/** The shared standing gate owns its complete verdict; this wrapper supplies identity only. */
export function FundraisersModuleGate(
  props: Omit<ComponentProps<typeof ModuleGate>, 'slug' | 'label'>,
) {
  return <ModuleGate {...props} slug={FUNDRAISERS_SLUG} label="Fundraisers" />;
}
